import {Component, Input, Output, OnInit,OnChanges, DoCheck, EventEmitter, ChangeDetectionStrategy, ViewEncapsulation} from '@angular/core'
import {DEFAULT_TEMPLATE, DEFAULT_STYLES} from './template';
import { CommonService } from '../common.service';

/**
 * The default pagination controls component. Actually just a default implementation of a custom template.
 */
@Component({
    selector: 'pagination-controls',
    template: DEFAULT_TEMPLATE,
    styles: [DEFAULT_STYLES],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PaginationControlsComponent implements OnInit,OnChanges {

    noRecords;
    allowPageChange:boolean = true;

    @Input() id: string;
    @Input() startLimit: number;
    @Input() maxSize: number = 7;
    @Input() canChangePage?:boolean = true;
    @Input() errorMessage?: string;
    @Input()
    get directionLinks(): boolean {
        return this._directionLinks;
    }
    set directionLinks(value: boolean) {
        this._directionLinks = !!value && <any>value !== 'false';
    }
    @Input()
    get autoHide(): boolean {
        return this._autoHide;
    }
    set autoHide(value: boolean) {
        this._autoHide = !!value && <any>value !== 'false';
    }
    @Input() previousLabel: string = 'Previous';
    @Input() nextLabel: string = 'Next';
    @Input() screenReaderPaginationLabel: string = 'Pagination';
    @Input() screenReaderPageLabel: string = 'page';
    @Input() screenReaderCurrentLabel: string = `You're on page`;
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

    private _directionLinks: boolean = true;
    private _autoHide: boolean = false;
    
    
    constructor(common: CommonService ) {
        this.noRecords = common.noRecords;
    }

    ngOnInit() { 
        // console.log(this.attachServiceGroup);
    }

    ngOnChanges(){
        this.allowPageChange = this.canChangePage;
    }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/pagination/pagination-controls.component.ts